import { useState, useEffect, useRef } from 'react';
import { IMMERSION_LIST } from '@portalCommon/constants';
import useVideoPreload from '@commonPackage/hooks/useVideoPreload';
import { Desc } from '@portalCommon/homeV3/Desc';
import { AnimatePresence, motion } from 'framer-motion';
import classnames from 'classnames/bind';
import { LazyVideo } from '@commonPackage/components';
import styles from './index.module.less';

const cx = classnames.bind(styles);

const IMMERSION_LIST_PC = IMMERSION_LIST.filter(({ using }) => using.includes('pc'));

const Immersion = () => {
  const videoRef = useRef(null);
  const [index, setIndex] = useState(0);
  const [mouseObserver, setMouseObserver] = useState(false);

  useVideoPreload({
    urls: IMMERSION_LIST_PC.map(item => item.video ?? ''),
  });

  useEffect(() => {
    let timer: any;
    if (!mouseObserver) {
      timer = setTimeout(() => {
        setIndex(i => (i + 1 >= IMMERSION_LIST_PC.length ? 0 : i + 1));
      }, 3000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [index, mouseObserver]);

  const handleMouseEnter = () => {
    setMouseObserver(true);
  };

  const handleMouseLeave = () => {
    setMouseObserver(false);
  };

  return (
    <div className={cx('immersion-wrapper')} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div className={cx('content')}>
        <div className={cx('left-text-side')}>
          <div className={cx('tab-line-background')} />
          <div className={cx('tab-wrapper')}>
            <AnimatePresence initial={false}>
              {IMMERSION_LIST_PC.map((item, i) => {
                const isSelected = index === i;
                return (
                  <div key={item.title} className={cx('tab-container')}>
                    <div
                      className={`${cx('tab-line')} ${isSelected ? cx('tab-line-select') : cx('tab-line-unselect')}`}
                    />
                    <div className={cx('tab', { select: isSelected })} onClick={() => setIndex(i)}>
                      <motion.div className={cx('tab-title', { 'tab-title-unselect': !isSelected })}>
                        {item.title}
                      </motion.div>
                      {isSelected && (
                        <motion.div
                          initial={{ height: 0 }}
                          animate={{ height: 'auto' }}
                          exit={{ height: 0 }}
                          transition={{ duration: 0.2, ease: 'easeOut' }}
                          className={cx('tab-desc')}>
                          <Desc desc={item.desc} />
                        </motion.div>
                      )}
                    </div>
                  </div>
                );
              })}
            </AnimatePresence>
          </div>

          <div className={cx('number')}>
            <div className={cx('count')}>{`0${index + 1}`}</div>
            <div className={cx('sum')}>05</div>
          </div>
        </div>
        <div className={cx('right-img-side')}>
          <div className={cx('display')}>
            <div className={cx('video-box')} ref={videoRef}>
              {IMMERSION_LIST_PC.map((item, _index) => {
                return (
                  <LazyVideo
                    inViewOptions={{
                      rootMargin: '800px',
                    }}
                    key={item.title}
                    className={cx('display', { hidden: _index !== index })}
                    src={item.video ?? ''}
                    muted
                    loop
                    videoRef={ref => {
                      try {
                        if (ref && ref.src && !ref.src.endsWith('png')) {
                          ref?.play();
                        }
                      } catch (error) {}
                    }}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Immersion;
